export default __webpack_public_path__ + "static/media/instructions2.712306f3.jpg";